import isEmpty from 'lodash/isEmpty'
import perMeterCalc from './perMeterCalc'
import find from './findMaxOrMinFrame'
import {RESIZE_FRAME} from "../constants/projectActions";

export default function({ originalW, originalH }, { deltaX, deltaY }, frames = [], perMeter = 100) {
  if (undefined === originalW || undefined === originalH) {
    const lowest = find(frames)
    return { w: lowest[0], h: lowest[1] }
  }
  if (isEmpty(frames)) {
    return { w: originalW, h: originalH}
  }

  const f = frames
    .map(frame => ({
      width: frame.width,
      height: frame.height,
      tmpWidth: perMeterCalc(frame.width, perMeter),
      tmpHeight: perMeterCalc(frame.height, perMeter),
    }))
    .filter(frame => frame.tmpWidth <= deltaX && frame.tmpHeight <= deltaY)

  if (isEmpty(f)) {
    return { w: originalW, h: originalH}
  }

  const result = f
    .sort((a, b) => {
      const aSize = a.width + a.height
      const bSize = b.width + b.height

      if (aSize === bSize) {
        return 0
      }

      return aSize > bSize ? -1 : 1
    })
    .shift()

    return  {
        w: result.width,
        h: result.height,
    }
}



// WEBPACK FOOTER //
// ./src/utils/matchFrameToResize.js